<template>
  <div class="bg-gray-100 p-10 min-h-full">
    <page-title title="Shipments" :btnText="btnText" btn="shipmentCreate" />
    <div class="flex justify-between mb-10">
      <div>
        <!-- <tabs @clicked="onClickTab" :tabCur="tabCur" /> -->
        <filters class="mt-2" @current-page="clickTab($event)" @select-mode="selectShipmentMode($event)" />
      </div>
      <div class="flex">
        <search-bar :placeholder="'Search for PO, TAGS, HBL, MBL'+[$can('manage','Shipment')?', Container no. or customer':' or Container no']" @search="searchShipment" />
      </div>
    </div>

    <shipment-list v-if="tabCur == 0" :shipments="shipments[0]" />
    <shipment-list v-if="tabCur == 1" :shipments="shipments[1]" />
    <shipment-requests v-if="tabCur == 2" :shipments="shipments[2]" />

    <div v-if="hasMore" class="flex justify-center mt-6">
      <button
        class="px-6 py-3 rounded-lg bg-sky-500 text-white duration-300"
        :class="loadingMore ? 'opacity-50 cursor-not-allowed' : ''"
        :disabled="loadingMore"
        @click="loadMore">
        {{ loadingMore ? 'Loading...' : 'Load more' }}
      </button>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Tabs from './components/tabs'
  import ShipmentRequests from './components/shipment_requests'
  import ShipmentList from './components/shipment_list'
  import Filters from './components/filters'
  // import Filter_checkbox from './components/filter_checkbox.vue'
  // import axios from 'axios';

  export default {
    data() {
      return {
        // searchQuery: null,
        style: this.$store.state.style,
        shipments: [[], [], []],
        tabCur: 0,
        btnText: null,
        currentSearchKeyword: '',
        shipmentTypes: [],
        offset: 0,
        hasMore: false,
        loadingMore: false
      }
    },

    computed: {
      ...mapState(['user'])
    },

    components: {
      Tabs, ShipmentRequests, ShipmentList, Filters
    },

    mounted() {
      this.setBtnText()
      // const path = this.$store.state.path[this.$store.state.env]
      this.getShipments()
    },

    methods: {
      getShipments(query, append = false) {
        // only the visible tab is rendered, so only ask for that one
        const params = new URLSearchParams({
          tab: this.tabCur,
          offset: append ? this.offset : 0
        })
        if (query) params.append('query', query)
        this.shipmentTypes.forEach(m => params.append('modes[]', m))

        if (append) this.loadingMore = true

        this.$ax.get(`shipments?${params.toString()}`)
          .then(res => {
            const page = res.data.shipments[this.tabCur] || []
            // replace the whole array: Vue 2 can't see `this.shipments[i] = x`
            const lists = append ? this.shipments.slice() : [[], [], []]
            lists[this.tabCur] = append ? lists[this.tabCur].concat(page) : page

            this.shipments = lists
            this.offset = lists[this.tabCur].length
            this.hasMore = !!res.data.has_more
          })
          .finally(() => {
            this.loadingMore = false
          })
      },

      loadMore() {
        if (this.loadingMore || !this.hasMore) return
        this.getShipments(this.currentSearchKeyword, true)
      },

      // any change of tab / search / mode restarts paging from the top
      resetAndFetch() {
        this.offset = 0
        this.getShipments(this.currentSearchKeyword)
      },

      searchShipment(res) {
        this.tabCur = 0
        this.currentSearchKeyword = res
        this.resetAndFetch()
      },
      setBtnText() {
        // this.btnText = this.$can('manage', 'Shipment') ? 'Create new shipment' : 'Request new shipment'
        this.btnText = this.$can('manage', 'Shipment') && 'Create new shipment'
      },

      onClickTab(value) {
        this.tabCur = value
        this.resetAndFetch()
      },

      clickTab(e) {
        this.tabCur = e
        this.resetAndFetch()
      },

      selectShipmentMode(e) {
        let m = JSON.parse(JSON.stringify(e))
        this.shipmentTypes = m
        this.resetAndFetch()
      }
    }
  }
</script>

<style scoped>
  .row-border {
    border-bottom-width: 1rem;
  }
</style>
